import { computed } from 'vue'
import { useFrontegg } from '@frontegg/vue'
import type { PermissionKey } from '@/config/permissions'

/**
 * Composable for checking user permissions in Vue components.
 * Uses Frontegg's reactive authState.
 */
export function usePerms() {
  const { authState } = useFrontegg()

  const permissions = computed(() => authState?.user?.permissions ?? [])

  function hasPerms(perm: PermissionKey | string): boolean {
    return permissions.value.some((p: { key?: string }) => p?.key === perm)
  }

  function hasAnyPerm(...perms: (PermissionKey | string)[]): boolean {
    return perms.some(perm => hasPerms(perm))
  }

  function hasAllPerms(...perms: (PermissionKey | string)[]): boolean {
    return perms.every(perm => hasPerms(perm))
  }

  return { hasPerms, hasAnyPerm, hasAllPerms, permissions }
}
